import React from 'react';
import PropTypes from 'prop-types';

function HitAccommodations(props) {
    let accomodations = [];

    if (props.bedrooms) {
        accomodations.push((
            <li key="bedrooms" className="hit-accommodation hit-bedrooms hidden-mini">
                {props.bedrooms}
            </li>
        ));
    }

    if (props.bathrooms) {
        accomodations.push((
            <li key="bathrooms" className="hit-accommodation hit-bathrooms hidden-mini">
                {props.bathrooms}
            </li>
        ));
    }

    if (props.sleeps) {
        accomodations.push((
            <li key="sleeps" className="hit-accommodation hit-sleeps hidden-mini">
                {props.sleeps}
            </li>
        ));
    }
    return (
        <ul className="hit-accommodations list-unstyled">
            {accomodations}
        </ul>
    );
}

HitAccommodations.propTypes = {
    bathrooms: PropTypes.string,
    bedrooms: PropTypes.string,
    sleeps: PropTypes.string
};

export default HitAccommodations;



// WEBPACK FOOTER //
// ./src/universal/components/Hit/HitSubComponents/HitAccommodations/HitAccommodations.js